<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <i class="fa fa-bars"></i> {{ $t('str.fault-finding') }}
            <div style="display:inline-block;">
              <b-form @submit.prevent="getList()">
                <b-input-group>
                  <b-form-input id="keyword" type="text" name="keyword" :placeholder="$t('str.search')"
                    v-model="keyword" @keyup.enter="getList()"></b-form-input>
                  <b-input-group-append>
                    <buttons button-type="search" />&nbsp;
                    <buttons button-type="reset_filter" @click="resetFilter()" />
                  </b-input-group-append>
                </b-input-group>
              </b-form>
            </div>
            <div class="card-header-actions">
              <router-link to="/content/fault-finding/manage/0" class="card-header-action btn-setting">
                <buttons button-type="add_new" />
              </router-link>
            </div>
          </div>
          <p :class="{'text-center': true, 'd-none': items.length}" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{'d-none': !items.length}" :hover="hover" :striped="striped" :bordered="bordered"
            :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="created_at" slot-scope="data">
              {{ data.item.created_at | moment('from', 'now') }}
            </template>
            <template slot="updated_at" slot-scope="data">
              {{ data.item.updated_at | moment('from', 'now') }}
            </template>
            <template slot="action" slot-scope="data">
              <router-link :to="'/content/fault-finding/manage/'+data.item.id">
                <buttons button-type="edit" />
              </router-link>
              &nbsp;
              <buttons button-type="un_publish" :published="data.item.is_published"
                @click="toggleIsPublished(data.item.id)" />
              &nbsp;
              <buttons button-type="delete" @click="confirmDelete(data.item.id)" />
            </template>
          </b-table>
          <nav :class="{'d-none': !items.length}">
            <paging :current-page="currentPage" :total-pages="totalPage" @page-changed="pageOneChanged" prev-text="Prev"
              next-text="Next" />
          </nav>
        </b-card>
      </b-col>
    </b-row>
    <confirm-modal :item="confirmDeleteId" @confirm="deleteData" @cancel="cancelDelete"></confirm-modal>
  </div>
</template>

<script>
import axios from 'axios'

import Pagination from '@/views/component/Pagination'
import ConfirmModal from '@/views/component/ConfirmModal'
import Buttons from '@/views/component/Buttons'

import * as Auth from '@/shared/auth'
import * as helper from '@/shared/helper'

const envi = process.env

export default {
  name: 'FaultFinding',
  components: {
    'paging': Pagination,
    'confirm-modal': ConfirmModal,
    'buttons': Buttons
  },
  props: {
    hover: { type: Boolean, default: false },
    striped: { type: Boolean, default: false },
    bordered: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false }
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'title_en', label: 'Title', sortable: true },
        { key: 'created_at', sortable: true },
        { key: 'updated_at', sortable: true },
        { key: 'action' }
      ],
      keyword: '',
      currentPage: 1,
      totalPage: 0,
      confirmDeleteModal: false,
      confirmDeleteId: '',
      categoryId: null,
      categoryList: [],
      categorySelect: []
    }
  },
  methods: {
    async getFaultFindingCategorySelect() {
      this.$auth.checkSession()
      try {
        var getData = await axios.get(`${envi.VUE_APP_API_URL}/FaultFindingCategory`, {
          headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
        })

        this.categoryList = getData.data.data

        for (var i = 0; i < this.categoryList.length; i++) {
        this.categorySelect.push({ 'value': this.categoryList[i].id, 'text': this.categoryList[i].name_en })
      }
      } catch (e) {
        console.log(e.response)
      }
    },
    setCategoryId(val) {
      this.categoryId = val
      this.getList()
    },
    async getList(page) {
      this.$auth.checkSession()
      var trail = `?limit=${envi.VUE_APP_PAGING_LIMIT}`
      if (page) trail = `${trail}&page=${page}`
      if (this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if (this.categoryId != null) trail = `${trail}&category=${this.categoryId}`

      try {
        var getData = await axios.get(`${envi.VUE_APP_API_URL}/FaultFinding${trail}`, {
          headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
        })

        this.items = getData.data.data
        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch (e) {
        console.log(e.response)
      }
    },
    async deleteData(id) {
      this.$auth.checkSession()
      try {
        var result = await axios.delete(`${envi.VUE_APP_API_URL}/FaultFinding/${id}`, {
          headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },
    async toggleIsPublished(id) {
      this.$auth.checkSession()
      try {
        var result = await axios.post(`${envi.VUE_APP_API_URL}/FaultFinding/toggle_publish`,
          {
            id: id
          }, {
          headers: { 'Authorization': `Bearer ${Auth.session.get().passport}` }
        })

        this.$toast.success(result.data.meta.message, '', {
          position: 'topCenter'
        })

        this.getList()
        this.confirmModal = false
      } catch (e) {
        console.log(e.response)
      }
    },
    resetFilter() {
      this.keyword = ''
      this.getList()
    },
    pageOneChanged(pageNum) {
      this.$auth.checkSession()
      this.currentPage = pageNum
      this.getList(pageNum)
    },
    confirmDelete(id) {
      this.$auth.checkSession()
      this.confirmDeleteModal = true
      this.confirmDeleteId = id
    },
    cancelDelete() {
      this.$auth.checkSession()
      this.confirmDeleteModal = false
    }
  },
  created() {
    this.getList()
  }
}
</script>